import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Button, Box } from '@nerdwallet/currency';
import { ASSETS_SOURCE } from './data';

import './awards-badge-dropdown.less';

const AwardsBadgeDropdownOutput = ({ id, awardsYear }) => {
  const badgeLink = get(ASSETS_SOURCE[awardsYear], `${id}.badgeLink`, {});

  return (
    <Box>
      <Box
        className={classNames([
          'awards-dropdown__button',
          classes('margin-horizontal-auto'),
          classes('margin-top-4'),
          classes('text-align-center'),
        ])}
      >
        <Button primary href={badgeLink}>
          DOWNLOAD FILES
        </Button>
      </Box>
    </Box>
  );
};

AwardsBadgeDropdownOutput.propTypes = {
  id: PropTypes.string,
  awardsYear: PropTypes.string,
};

export default AwardsBadgeDropdownOutput;
